import type { ISaveEnquiryResponse } from '@/composables/interfaces/apiInterfaces'
import { EnquiryBarOrigin, type IEnquiryDto } from '@/composables/interfaces/appInterfaces'
import { EnquiryBarOriginLocalStorage, EnquiryDataLocalStorage } from '@/constants'
import { ref } from 'vue'
import { filterStore } from './filter.store'

export const enquiryData = ref<IEnquiryDto>()

export const enquiryBarOrigin = ref<EnquiryBarOrigin>()

export const enquirySubmittedSuccessfully = ref(false)

export const landingPageRoomId = ref<number>()
export const landingPagePackageId = ref<number>()

export function trackEnquiry(enquiryData: IEnquiryDto, result: ISaveEnquiryResponse, landingPageEnquiry: boolean): void {
  // window.siteEventEnquiry is only declared in portal project, here locally its missing
  if (landingPageEnquiry) {
    window.siteEventEnquiryLandingPage && window.siteEventEnquiryLandingPage(enquiryData.enquiryType, enquiryData.language)
  } else {
    window.siteEventEnquiry && window.siteEventEnquiry(enquiryData, result)
  }
}

export function setBoardingsToOnlyAccomodationIfEmptyArray(): void {
  if (filterStore.value.boardingIds.length == 0) filterStore.value.boardingIds.push(0)
}

export function setEnquiryDataFromLocalStorage(): void {
  let enquiryDataLocalStorage = localStorage.getItem(EnquiryDataLocalStorage)
  if (enquiryDataLocalStorage != null) {
    enquiryDataLocalStorage = atob(enquiryDataLocalStorage)
    var x = JSON.parse(enquiryDataLocalStorage) as IEnquiryDto
    if (x != null) enquiryData.value = x
  }
}

export function initEnquiryBarOriginFromLocalStorage(): void {
  const localStorageData = localStorage.getItem(EnquiryBarOriginLocalStorage)
  if (localStorageData != null) {
    const storedData: EnquiryBarOrigin = JSON.parse(localStorageData)
    enquiryBarOrigin.value = storedData
  }
}

export function setEnquiryBarOriginToLocalStorage(origin: EnquiryBarOrigin): void {
  localStorage.setItem(EnquiryBarOriginLocalStorage, JSON.stringify(origin))
}
